import { createContext, useContext, useState, ReactNode } from "react";

export interface UpgradeModalOptions {
  triggerSource: string;
  toolName?: string;
}

interface UpgradeModalContextType {
  isOpen: boolean;
  options: UpgradeModalOptions | null;
  openUpgradeModal: (opts: UpgradeModalOptions) => void;
  closeUpgradeModal: () => void;
}

const UpgradeModalContext = createContext<UpgradeModalContextType | null>(null);

export function UpgradeModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<UpgradeModalOptions | null>(null);

  const openUpgradeModal = (opts: UpgradeModalOptions) => {
    setOptions(opts);
    setIsOpen(true);
    console.log("[upgrade-intent]", {
      triggerSource: opts.triggerSource,
      toolName: opts.toolName,
      timestamp: new Date().toISOString(),
    });
  };

  const closeUpgradeModal = () => {
    setIsOpen(false);
  };

  return (
    <UpgradeModalContext.Provider value={{ isOpen, options, openUpgradeModal, closeUpgradeModal }}>
      {children}
    </UpgradeModalContext.Provider>
  );
}

export function useUpgradeModal() {
  const ctx = useContext(UpgradeModalContext);
  if (!ctx) throw new Error("useUpgradeModal must be used within UpgradeModalProvider");
  return ctx;
}
